import { Render } from '@/components/Helpers/ComponentRender/Render';
import PlayIcon from '@/components/icons/PlayIcon';
import { EventTracker } from '@/utils';
import { cn } from '@/utils/styles';
import { VideoList } from '@viome/viome-base/src/usecase/Education/EducationModel';

const EducationVideoCard = ({
  videoData,
  screen,
  'data-testid': testId,
}: {
  videoData: VideoList;
  screen: string;
  'data-testid'?: string;
}) => {
  const handleYoutubeRedirection = (externalLink: string) => {
    window.open(externalLink, '_blank', 'noopener,noreferrer');
  };
  const themeMode = screen === 'health' ? 'dark' : 'light';
  const imageUrl = videoData?.image_url.replace(/'/g, "\\'");

  return (
    <div
      className="flex flex-col gap-2 justify-center cursor-pointer"
      onClick={() => {
        EventTracker.trackEvent(
          screen,
          `${screen}_jny_deeper_video_${videoData.video_id}`,
        );
        handleYoutubeRedirection(videoData.link);
      }}
      data-testid={testId}
    >
      <div
        className="bg-cover bg-center rounded-lg p-4 flex flex-col justify-between"
        style={{
          height: '12rem',
          backgroundImage: `url(${imageUrl})`,
        }}
        data-testid={testId ? `${testId}-thumbnail` : undefined}
      >
        <PlayIcon />
        <Render when={videoData?.subtitle}>
          <p className="typography-caption1 text-white" data-testid={testId ? `${testId}-subtitle` : undefined}>
            {videoData?.subtitle}
          </p>
        </Render>
      </div>
      <p className={cn(`typography-headline3 text-primary ${themeMode}`)} data-testid={testId ? `${testId}-title` : undefined}>
        {videoData?.video_title}
      </p>
    </div>
  );
};

export default EducationVideoCard;
